import {createFileRoute} from '@tanstack/react-router';
import CoursePage from '../../../../pages/CoursePage';

export const Route = createFileRoute('/_authenticated/courses/$courseId/')({
  component: function CourseIndexRoute() {
    const {courseId} = Route.useParams();
    return <CoursePage courseId={courseId} />;
  },
});
